/* eslint-disable  */
export default class Size {
    name: string;
    age_size: string;

    constructor(name = "", age_size ="") {
        this.name = name;
        this.age_size = age_size
    }
}